var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { deleteDataFomCollection, updateDataFromCollection } from './utils';
import moment from 'moment';
import { setAllTasks } from './tasks';
const initialState = {
    fetchLoading: false,
    updateLoading: false,
    allActivities: {
        data: [],
        loading: false,
        count: 0,
    },
    error: null,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const fetchAllActivities = createAsyncThunk('reduxActivities/fetchAll', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.activities.fetchAll();
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchUserActivities = createAsyncThunk('reduxActivities/users/fetchAll', (queries_1, _a) => __awaiter(void 0, [queries_1, _a], void 0, function* (queries, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.activities.fetchAll(null, queries);
        return fulfillWithValue(response);
    }
    catch (err) {
        console.log('err', err);
        return rejectWithValue(err);
    }
}));
export const fetchUserActivitiesWithTaskRelation = createAsyncThunk('reduxActivitiesWithTaskRelation/users/fetchAll', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ userId, queries }, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const response = yield api.users.activities({ id: userId }, queries);
        const tasks = response.results.map((activity) => activity.taskInst).filter((_) => _);
        dispatch(setAllTasks(tasks));
        return fulfillWithValue(response);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchMyActivities = createAsyncThunk('myActivities/fetchAll', (queries_1, _a) => __awaiter(void 0, [queries_1, _a], void 0, function* (queries, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.users.myActivities({}, Object.assign(Object.assign({}, queries), { statMode: 'datasOnly' }));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchTodayMyActivities = createAsyncThunk('myTodayActivities/fetchAll', (queries_1, _a) => __awaiter(void 0, [queries_1, _a], void 0, function* (queries, { fulfillWithValue, rejectWithValue }) {
    try {
        const todayDate = moment().format('YYYY-MM-DD');
        const res = yield api.users.myActivities({ date__range: `${todayDate},${todayDate}` }, Object.assign(Object.assign({}, queries), { statMode: 'datasOnly' }));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const createActivity = createAsyncThunk('reduxActivities/create', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ createdActivities, isFromMyHours }, { fulfillWithValue, rejectWithValue, getState }) {
    var _c, _d;
    try {
        // CREATE RELATION WITH TASKINST. TO DO : RETRIEVE RELATION IN SELECTOR INSTEAD
        const { user } = createdActivities[0];
        const activeUser = (_c = getState().user) === null || _c === void 0 ? void 0 : _c.asset;
        const tasks = [...(_d = getState().reduxTasks) === null || _d === void 0 ? void 0 : _d.data, ...Object.values(getState().tasks.resources)];
        const response = yield api.activities.collection.create(createdActivities);
        const responseWithRelation = response.map((activity) => {
            const relation = tasks.find((task) => task.id === activity.task);
            return Object.assign(Object.assign({}, activity), { taskInst: relation, updatedAt: Date.now() });
        });
        return fulfillWithValue({
            response: responseWithRelation,
            isMyActivity: isFromMyHours || user === activeUser,
        });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateActivity = createAsyncThunk('reduxActivities/update', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ activities, isFromMyHours }, { fulfillWithValue, rejectWithValue, getState }) {
    var _c, _d;
    try {
        const { user } = activities[0];
        const activeUser = (_c = getState().user) === null || _c === void 0 ? void 0 : _c.asset;
        const tasks = [...(_d = getState().reduxTasks) === null || _d === void 0 ? void 0 : _d.data, ...Object.values(getState().tasks.resources)];
        const response = yield api.activities.collection.update(activities);
        const responseWithRelation = response.map((activity) => {
            const relation = tasks.find((task) => task.id === activity.task);
            return Object.assign(Object.assign({}, activity), { taskInst: relation, updatedAt: Date.now() });
        });
        return fulfillWithValue({
            response: responseWithRelation,
            isMyActivity: isFromMyHours || user === activeUser,
        });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const deleteActivity = createAsyncThunk('reduxActivities/delete', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ activitiesIds, isFromMyHours }, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.activities.collection.delete(activitiesIds.map((id) => ({ id })));
        return fulfillWithValue({ activitiesIds, isMyActivity: isFromMyHours });
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
// actions for middleware
export const createActivityAction = createActivity.fulfilled;
export const deleteActivityAction = deleteActivity.fulfilled;
export const updateActivityAction = updateActivity.fulfilled;
const { actions, reducer } = createSlice({
    name: 'reduxActivities',
    initialState,
    reducers: {
        setAllActivities: (state, { payload }) => {
            const activities = [...payload, ...state.allActivities.data];
            const newData = removeDuplicates(activities, (activity) => activity.id);
            state.allActivities.data = newData;
        },
    },
    extraReducers: (builder) => {
        // FETCH ALL ACTIVITIES
        builder.addCase(fetchAllActivities.pending, (state) => {
            state.fetchLoading = true;
        });
        builder.addCase(fetchAllActivities.fulfilled, (state, { payload }) => {
            const activities = [...state.allActivities.data, ...payload];
            const newData = removeDuplicates(activities, (activity) => activity.id);
            state.allActivities.data = newData;
            state.fetchLoading = false;
        });
        builder.addCase(fetchAllActivities.rejected, (state, { payload }) => {
            state.error = payload;
            state.fetchLoading = false;
        });
        // FETCH USER ACTIVITIES
        builder.addCase(fetchUserActivitiesWithTaskRelation.pending, (state) => {
            state.fetchLoading = true;
        });
        builder.addCase(fetchUserActivitiesWithTaskRelation.fulfilled, (state, { payload }) => {
            const activities = [...state.allActivities.data, ...payload.results];
            const newData = removeDuplicates(activities, (activity) => activity.id);
            state.allActivities.data = newData;
            state.fetchLoading = false;
        });
        builder.addCase(fetchUserActivitiesWithTaskRelation.rejected, (state, { payload }) => {
            state.error = payload;
            state.fetchLoading = false;
        });
        // FETCH MY ACTIVITIES
        builder.addCase(fetchMyActivities.pending, (state) => {
            state.fetchLoading = true;
        });
        builder.addCase(fetchMyActivities.fulfilled, (state, { payload }) => {
            const activities = [...state.allActivities.data, ...payload.results];
            const newData = removeDuplicates(activities, (activity) => activity.id);
            state.allActivities.data = newData;
            state.fetchLoading = false;
        });
        builder.addCase(fetchMyActivities.rejected, (state, { payload }) => {
            state.error = payload;
            state.fetchLoading = false;
        });
        // FETCH TODAY MY ACTIVITIES
        builder.addCase(fetchTodayMyActivities.pending, (state) => {
            state.fetchLoading = true;
        });
        builder.addCase(fetchTodayMyActivities.fulfilled, (state, { payload }) => {
            const activities = [...state.allActivities.data, ...payload.results];
            const newData = removeDuplicates(activities, (activity) => activity.id);
            state.allActivities.data = newData;
            state.fetchLoading = false;
        });
        builder.addCase(fetchTodayMyActivities.rejected, (state, { payload }) => {
            state.error = payload;
            state.fetchLoading = false;
        });
        // CREATE ACTIVITY
        builder.addCase(createActivity.pending, (state) => { });
        builder.addCase(createActivityAction, (state, { payload }) => {
            const { response } = payload;
            state.allActivities.data = [...state.allActivities.data, ...response];
        });
        builder.addCase(createActivity.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // UPDATE ACTIVITY
        builder.addCase(updateActivity.pending, (state) => {
            state.updateLoading = true;
        });
        builder.addCase(updateActivity.fulfilled, (state, { payload }) => {
            const { response } = payload;
            const newMyActivitiesData = updateDataFromCollection(state.allActivities.data, response);
            state.allActivities.data = newMyActivitiesData;
        });
        builder.addCase(updateActivity.rejected, (state, { payload }) => {
            state.error = payload;
            state.updateLoading = false;
        });
        // DELETE ACTIVITY
        builder.addCase(deleteActivity.pending, (state) => { });
        builder.addCase(deleteActivity.fulfilled, (state, { payload }) => {
            const { activitiesIds } = payload;
            const newMyActivitiesData = deleteDataFomCollection(state.allActivities.data, activitiesIds);
            state.allActivities.data = newMyActivitiesData;
        });
        builder.addCase(deleteActivity.rejected, (state, { payload }) => {
            state.error = payload;
        });
    },
});
export const { setAllActivities } = actions;
export default reducer;
